<template>
  <!-- New -->
  <nav :class="{hide: fullscreen}">
    <div class="logo">
      <router-link to="/wallboards">
        <img src="../assets/innovovoice-logo.svg" width="160px" alt="InnovoVoice Logo">
      </router-link>
    </div>
    <div class="nav-links">
      <ul>
        <li><router-link to="/wallboards">Home</router-link></li>
      </ul>
      <button class="iv-btn outline" @click="logout()">Logout</button>
    </div>
  </nav>
  
  <!-- Old -->
  <!-- <div class="navbar" :class="{hide: fullscreen}">
    <router-link to="/wallboards">Home</router-link>
    <a class="right" v-on:click="logout()">Logout</a>
  </div> -->
</template>

<script>
import auth from "../utils/auth";
export default {
  name: "navbar",
  methods: {
    isLoggedIn() {
      return auth.isAuthenticated();
    },
    logout() {
      auth.logout();
      this.$router.push("Login");
      return;
    }
  },
  computed: {
    fullscreen() {
      return this.$store.state.fullscreen;
    }
  }
};
</script>

<style scoped lang="scss">
  /* New */
  nav {
    height: 80px;
    padding: 0 60px;
    display: flex;
    background-color: #fff;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid darken($white, 10%);
    .nav-links {
      display: flex;
      align-items: center;
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          display: inline-block;
          margin-left: 40px;
          &:first-child {
            margin-left: 0;
          }
          a {
            text-decoration: none;
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            color: lighten($black, 40%);
            transition: all 0.2s ease;
            &:hover, &:focus, &:active {
              color: $primary;
            }
          }
        }
      }
      button {
        margin-left: 40px;
      }
    }
  }

  /* Old */
  /* .navbar {
    background-color: #333;
    overflow: hidden;
  }
  .navbar a {
    float: left;
    color: #f2f2f2;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 17px;
    cursor: pointer;
  }

  .navbar a.right {
    float: right;
  }

  .navbar a:hover {
    background-color: #ddd;
    color: black;
  }

  .navar a:active {
    background-color: #4caf50;
    color: white;
  } */
</style>
